// Report queries (slice 3): the Clients facts. Read only: every finance
// mutation refetches them with the rest of ["finance"].
import { useQuery } from "@tanstack/react-query";
import { reportService } from "../services/reportService";
import { financeKeys } from "./financeQuery";

export const reportKeys = {
  clients: () => [...financeKeys.all, "clients"] as const,
};

export const useClientSummaries = () => useQuery({ queryKey: reportKeys.clients(), queryFn: reportService.clients });
